// extracted by mini-css-extract-plugin
export default {"header":"HDvvaj","placeholder":"qJrN4A"};